/**
 * Modèles de départ d'une campagne. Rien côté serveur : un modèle n'est qu'un
 * texte d'introduction et un objet suggérés, posés à la création avec les
 * blocs et le sujet que l'API accepte déjà.
 */
export const MODELES_CAMPAGNE = ['vierge', 'vernissage', 'nouveautes', 'actualite'] as const;
export type ModeleCampagne = (typeof MODELES_CAMPAGNE)[number];
